import { xml2ast, allHtmlParsers, printAST, htmlNodeToLatexPrinter, textNodeToLatexPrinter } from '@utils/ast';

function convertIGuideHtmlToLatex(html) {
  const ast = xml2ast(html, allHtmlParsers, "text/html");
  return printAST(ast, {
    html: htmlNodeToLatexPrinter,
    text: textNodeToLatexPrinter
  }).join("\n");
}

export { convertIGuideHtmlToLatex };
//# sourceMappingURL=util.html-to-latex.js.map
